/**
 * GrowthBook fetches feature definitions only when all of these are set:
 * - NEXT_PUBLIC_GROWTHBOOK_ENABLED === 'true'
 * - NEXT_PUBLIC_GROWTHBOOK_API_HOST
 * - NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY
 *
 * Otherwise the SDK stays offline: no GrowthBook API traffic, {@link useExperiment}
 * defaults apply, and inline experiments resolve to the first variation.
 */
export function isGrowthBookRemoteEnabled(): boolean {
  return (
    process.env.NEXT_PUBLIC_GROWTHBOOK_ENABLED === 'true' &&
    Boolean(process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST) &&
    Boolean(process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY)
  )
}
